import { Directive, ElementRef, HostBinding, HostListener } from '@angular/core';

@Directive({
  selector: '[appDragTranslate]',
  standalone: true
})
export class DragTranslateDirective {
  constructor(
    private elRef: ElementRef<HTMLElement>,
  ) {}

  @HostBinding('class.is-drag') isMouseDown: boolean = false;
  @HostBinding('class.is-drag-move') isMouseMove: boolean = false;

  lastOffsetX: number = 0;
  deltaDrag: number = 0;
  startDragPosition: number = 0;

  @HostListener('mousedown', ['$event'])
  onMouseDown($event: MouseEvent) {
    this.isMouseDown = true;
    this.startDragPosition = $event.clientX;
  }

  @HostListener('mouseup')
  onMouseUp() {
    this.isMouseDown = false;
    this.isMouseMove = false;

    if(this.deltaDrag < 0){
      this.deltaDrag = 0;
    }

    const tapeWidth = this.elRef.nativeElement.scrollWidth - this.elRef.nativeElement.getBoundingClientRect().width
    if(this.deltaDrag > tapeWidth){
      this.deltaDrag = tapeWidth;
    }
    this.lastOffsetX = this.deltaDrag;
  }

  @HostListener('mousemove', ['$event'])
  onMouseMove($event: MouseEvent) {
    if(!this.isMouseDown){return}
    this.isMouseMove = true;
    this.deltaDrag = this.lastOffsetX + this.startDragPosition - $event.clientX;

    this.setTapeTranslate(this.deltaDrag)
  }

  private setTapeTranslate(translate: number){
    this.elRef.nativeElement.scrollTo(translate, 0)
  }
}
